import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * The "Add" button on the brush offer inside the cart (snippets/alekhyam-cart-extras.liquid).
 * It adds one brush set and announces the change the way the theme does, so the cart
 * drawer and the cart page redraw with the new line, the progress bar and the totals.
 */
async function addBrushes(button) {
  const root = window.Shopify?.routes?.root || '/';
  const variantId = button.dataset.akCartAdd;
  button.disabled = true;
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );
  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error(`cart add ${response.status}`);
    const cart = await fetch(`${root}cart.js`).then((reply) => reply.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'alekhyam-cart-extras', didError: false },
    });
  } catch (error) {
    deferred.reject(error);
    button.disabled = false;
  }
}

if (!window.alekhyamCartExtras) {
  window.alekhyamCartExtras = true;
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-ak-cart-add]') : null;
    if (button instanceof HTMLButtonElement && !button.disabled) addBrushes(button);
  });
}
